/* Ability Warehouse — Stream B article add-on (vanilla, no dependencies).
   Loaded in addition to guide.js. Handles ONLY the new checklist device:
   - tick / untick with per-viewer persistence in localStorage (try/catch; degrades gracefully)
   - a live "X of Y done" count
   - for pre_purchase / pre_setup checklists, assembles the ticked items that map to a product into a
     visible suggested shopping list with Add-to-cart buttons.
   Add-to-cart itself, the member price and the toast are all inherited from guide.js: the buttons we
   render use [data-add-dyn][data-vid], which guide.js already listens for at the document level. */
(function () {
  'use strict';
  var root = document.querySelector('[data-article]');
  if (!root) return;

  /* The hero "Jump to the checklist" uses guide.js's [data-first-picks] target; mark the first
     interactive block (checklist / product row / compare) so the jump and the #picks anchor work. */
  (function () {
    var fp = root.querySelector('[data-checklist], .guide__cards, .guide__compare');
    if (fp) {
      if (!root.querySelector('[data-first-picks]')) fp.setAttribute('data-first-picks', '');
      if (!document.getElementById('picks')) fp.id = 'picks';
    }
  })();

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* Live product data printed by the section (handle -> {vid,title,img,url,price_money,member_save,available}) */
  var PRODUCTS = {};
  var dataEl = root.querySelector('[data-guide-products]');
  if (dataEl) { try { JSON.parse(dataEl.textContent).forEach(function (p) { PRODUCTS[p.handle] = p; }); } catch (e) {} }

  function lsGet(key) { try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : []; } catch (e) { return []; } }
  function lsSet(key, arr) { try { localStorage.setItem(key, JSON.stringify(arr)); } catch (e) {} }

  Array.prototype.slice.call(root.querySelectorAll('[data-checklist]')).forEach(function (cl) {
    var key = cl.getAttribute('data-key') || '';
    var kind = cl.getAttribute('data-kind') || 'room_audit';
    var buildList = kind === 'pre_purchase' || kind === 'pre_setup';
    var boxes = Array.prototype.slice.call(cl.querySelectorAll('[data-ck-box]'));
    var countEl = cl.querySelector('[data-check-count]');
    var listWrap = cl.querySelector('[data-check-list]');
    var listCards = cl.querySelector('[data-check-list-cards]');
    if (!boxes.length) return;

    var saved = lsGet(key);
    boxes.forEach(function (b) { if (saved.indexOf(b.value) > -1) b.checked = true; });

    function renderList() {
      if (!buildList || !listWrap || !listCards) return;
      var seen = {}, html = '', n = 0;
      boxes.forEach(function (b) {
        if (!b.checked) return;
        var li = b.closest('[data-ck-item]');
        var handle = li && li.getAttribute('data-handle');
        if (!handle || seen[handle]) return;
        var p = PRODUCTS[handle];
        if (!p) return;
        seen[handle] = 1; n++;
        var price = p.price_money ? esc(p.price_money) + (p.member_save ? ' <span class="gcm__mem">Members save ' + esc(p.member_save) + '</span>' : '') : '';
        var add = (p.available && p.vid)
          ? '<button type="button" class="gcm__add" data-add-dyn data-vid="' + esc(p.vid) + '" aria-label="Add ' + esc(p.title) + ' to cart">Add</button>'
          : '<a class="gcm__add gcm__add--ghost" href="' + esc(p.url) + '">View</a>';
        html += '<div class="article__check-li">' +
          (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="42" height="42">' : '<span style="width:42px;height:42px;flex:none"></span>') +
          '<span class="article__check-txt"><a class="article__check-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          (price ? '<span class="article__check-price">' + price + '</span>' : '') + '</span>' + add + '</div>';
      });
      if (n) { listCards.innerHTML = html; listWrap.hidden = false; }
      else { listCards.innerHTML = ''; listWrap.hidden = true; }
    }

    function update(save) {
      var done = 0;
      boxes.forEach(function (b) { if (b.checked) done++; });
      if (countEl) {
        countEl.textContent = done + ' of ' + boxes.length + ' ticked';
        countEl.classList.toggle('is-some', done > 0);
      }
      if (save) lsSet(key, boxes.filter(function (b) { return b.checked; }).map(function (b) { return b.value; }));
      renderList();
    }

    cl.addEventListener('change', function (e) { if (e.target && e.target.hasAttribute('data-ck-box')) update(true); });
    update(false);
  });
})();
